import { service } from '.';

export default {
  getOne: (id) => service.get(`/pickup/${id}`),
  getResolved: (date) => service.get(`/pickup/resolved_date/${date}`),
  create: (data) => service.post(`/pickup/new`, data),
  update: (data) => service.put(`/pickup/edit`, data),
};
